<template>
    <div>
        <Portlet class="right-panel" :fullHeight="true" :noPadding="true">
            <template slot="Title">
              Day templates
            </template>
            <template slot="Options">
                <!---->
            </template>
            <template slot="Content">
                <div id="dayTemplate-source" class="accordion">
                    <template v-for="section in sections">
                        <ItemMenuList :key="section.key" :isLoading="isLoadingDayTemplates" :noAction="true" >
                            <template slot="Content">
                                <div :class="['category']" >
<!--                                    <i :class="['fas', expandedSections.includes(section.key) === true ? 'fa-chevron-down' : 'fa-chevron-right' ]"></i>-->
<!--                                    <a href="#" class="hlp hlp__uppercase">{{section.key === 'UNDEFINED' ? section.type : section.key}}</a>-->
                                </div>
                                <b-list-group v-if="section.items && expandedSections.includes(section.key)" class="day-template__source-panel--list-group">
                                    <MenuCard v-for="template in section.items" :key="template.uid" :isDraggable="true" :disableLink="true" :menuItem="template" :itemType="section.type" :href="''">

                                      <template slot="Decorator">
                                            <span @click="emitEvent(section.event,template)">
                                                <i class="fas fa-circle" :style="{ color: template.colorCode }"></i>
                                            </span>
                                        </template>
                                        <template slot="Badge">
                                            <span></span>
                                        </template>
                                    </MenuCard>
                                </b-list-group>
                            </template>
                        </ItemMenuList>
                    </template>
                </div>
            </template>
        </Portlet>
    </div>
</template>
<script>
    import Translations from '@/store/translations';
    import router from '@/router';
    import EventBus from '@/eventbus';
    import Portlet from '@/components/common/Portlet.vue'
    import WaitingBlock from '@/components/common/WaitingBlock.vue'
    import ItemMenuList from '@/components/common/ItemMenuList.vue'
    import MenuCard from'@/components/common/MenuCard'
    import Constants from "@/store/constants";
    import { mapState } from 'vuex';
    import VueCookie from 'vue-cookie';
    // Tell Vue to use the plugin
    //Vue.use(VueCookie);
    export default {
        name: "WeekTemplateSourcePanel",
        mounted() {
          this.toggleSection('Day templates');
        },
        components: { Portlet, WaitingBlock, ItemMenuList, MenuCard },
        computed: {
            Constants: () => Constants.boxTypes,
            ...mapState({
              isLoadingDayTemplates: state => state.loadingStates.isLoadingStationDayTemplates,
              dtList: state => state.stationDayTemplates,
                isLoadingStationClocks: state => state.loadingStates.isLoadingStationClocks,
                isLoadingStationBoxess: state => state.loadingStates.isLoadingStationBoxes,
                boxListGrouped: state => state.stationBoxesGrouped,
                stationClocks: state => {
                    if (state.stationClocks == null) return [];
                    return state.stationClocks.items;
                },
            }),
            sections() {
                console.log(this.dtList)
               // this.$store.dispatch('loadStationDayTemplates', this.$store.state.currentStationUid);
                if(this.dtList){
                  console.log(this.dtList.items)
                  var sections = [{ key: "Day templates", type: 'template', event: "addTemplateToWeekTemplate", name: "template", items: this.dtList.items}];
                }


               // this.toggleSection('Day templates');
                return sections;
            }
        },
        data() {
            var allowedBoxTypes = [Constants.boxTypes.BOX, Constants.boxTypes.PODCAST];
            var allowedTrackTypes = [Constants.trackTypes.MUSIC, Constants.trackTypes.JINGLE, Constants.trackTypes.VOICE_TRACK];
            return {
                expandedSections: [],
                allowedBoxTypes,
                allowedTrackTypes
            }
        },
        methods: {
            emitEvent: function (eventName, clock) {
                console.log(eventName);
                EventBus.$emit(eventName, clock);
            },
            toggleSection(sectionKey) {
              console.log(sectionKey)
                let expandedSectionsCopy = [...this.expandedSections];
                if(expandedSectionsCopy.includes(sectionKey)) {
                    expandedSectionsCopy = expandedSectionsCopy.filter(key => key !== sectionKey);
                } else {
                    expandedSectionsCopy = [...expandedSectionsCopy, sectionKey]
                }
                this.expandedSections = expandedSectionsCopy;
            }
        }
    }
</script>
<style lang="scss">
    @import "global_var";
    .accordion {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: auto;
    }

        .day-template__source-panel--list-group {
            overflow: auto
        }

        .accordion div.items-menu-container {
            // flex-grow: 0;
            // height: 45px; /* Default header size */
        }

            .accordion div.items-menu-container.expanded {
                // flex-grow: 1;
                position: relative;
            }

                .accordion div.items-menu-container.expanded .items-menu-list {
                    overflow: hidden;
                    height: 100%;
                }

                .accordion div.items-menu-container.expanded .list-group {
                    overflow: auto;
                }

                    /* .accordion div.items-menu-container.expanded .list-group .list-group-item {} */

    .menu-label {
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    div.category i {
        width: 18px;
    }

    span.decorator a {
        text-decoration: none;
    }

    span.decorator a {
        display: inline-block;
        width: 18px;
    }


    .list-group-item:hover span.decorator a i.fa-plus {
        display: inline;
    }

    span.decorator a i.fa-circle {
        display: inline;
    }

    .m-content .right-panel {
        width: 250px;
        margin-left: 10px;
    }
</style>
